var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LandCard',{attrs:{"title":"贷款区域排名","isLeftMore":false}},[_c('div',{staticClass:"echartStyle"},[_c('chart',{attrs:{"options":_vm.options}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }